import config from 'frontend-payments/config/environment';

/**
 * Get the API base URL from environment configuration
 * Handles both development (localhost) and production environments
 */
export function getApiBaseUrl(): string {
  // In development, use staging
  if (config.environment === 'development') {
    return 'https://pay-staging.mylighthouse.com/api/v4';
  }

  // In production/staging, use relative URLs
  return '/api/v4';
}
